import React from "react";
import PropTypes from "prop-types";
import { conditionallyAddStyles, isColorWhite } from "../../../support/helpers";

const propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const SolidColorIndicator = ({ colors }) => {
  const defaultClasses = [
    "rounded-full",
    "w-full",
    "h-full",
    "flex",
    "flex-col",
    "overflow-hidden",
  ];

  conditionallyAddStyles(isColorWhite(colors), defaultClasses, "border");

  return (
    <div className={defaultClasses.join(" ")}>
      {colors.map((color) => (
        <div
          key={color}
          className="flex-grow"
          style={{ backgroundColor: color }}
        ></div>
      ))}
    </div>
  );
};

SolidColorIndicator.propTypes = propTypes;

export default SolidColorIndicator;
